import { Link } from 'react-router-dom';
import type { Star } from '@/mocks/stars';

interface StarCardProps {
  star: Star;
}

export default function StarCard({ star }: StarCardProps) {
  return (
    <Link
      to={`/star/${star.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-square w-full overflow-hidden bg-background-200">
        <img
          src={star.avatar}
          alt={`${star.name} 明星资料头像`}
          title={`${star.name} 河北彩花明星资料`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500/95 px-2 py-0.5 text-xs font-medium text-accent-950">
          {star.profession}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {star.name}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {star.constellation} · {star.nationality} · {star.birthYear}年生
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{star.bio}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {star.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}